export const SITE = {
  name: "Paras Real Estate",
  owner: "Sunil Aggarwal",
  ownerRole: "Founder & Property Consultant",
  phoneDisplay: "+91 79885 00427",
  phoneRaw: "+917988500427",
  phoneHref: "tel:+917988500427",
  whatsapp: "https://wa.me/917988500427",
  email: "aggarwalsunilhisar@gmail.com",
  contact2: {
    name: "Hemant (Bunty)",
    phoneDisplay: "+91 98126 13100",
    phoneHref: "tel:+919812613100",
  },
  location: "Dholera Smart City, Gujarat",
  mapsEmbed:
    "https://maps.google.com/maps?q=Dholera%20Special%20Investment%20Region%2C%20Gujarat&z=10&t=k&output=embed",
  mapsLink:
    "https://www.google.com/maps/search/?api=1&query=Dholera+Special+Investment+Region+Gujarat",
  heroImage:
    "https://images.unsplash.com/photo-1543996991-51fe458abfbd?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920",
  aboutImage: "/og-banner.jpg",
};

export const NAV = [
  { label: "Home", href: "#home" },
  { label: "Why Dholera", href: "#why-dholera" },
  { label: "About Us", href: "#about" },
  { label: "Properties", href: "#properties" },
  { label: "Projects", href: "#projects" },
  { label: "Investment Guide", href: "#investment-guide" },
  { label: "FAQs", href: "#faqs" },
  { label: "Contact", href: "#contact" },
];

export const HERO_STATS = [
  { value: "920 sq km", label: "Notified Dholera SIR area" },
  { value: "109 km", label: "Ahmedabad–Dholera Expressway, operational" },
  { value: "~45 min", label: "Ahmedabad to Dholera via expressway" },
  { value: "22.5 sq km", label: "Activation Area under development" },
];

export const MARQUEE_ITEMS = [
  "Dholera Special Investment Region",
  "Ahmedabad–Dholera Expressway — Operational",
  "Dholera International Airport — Under Development",
  "920 sq km Notified Greenfield Smart City",
  "Residential · Commercial · Industrial Plots",
  "A DMIC Legacy Project of Gujarat",
];

export const WHY_CARDS = [
  {
    title: "A Smart City Planned from the Ground Up",
    body: "Dholera Special Investment Region (SIR) is one of India's most ambitious greenfield industrial smart cities, developed along the Delhi–Mumbai Industrial Corridor. The Dholera Industrial City Development Ltd. (DICDL) — a 51:49 joint venture of the Government of Gujarat and the Government of India — drives its implementation.",
    tag: "Official Fact",
    featured: true,
    image:
      "https://images.unsplash.com/photo-1501276276428-88ec0b385919?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  },
  {
    title: "Expressway-Connected to Ahmedabad",
    body: "The 109-km access-controlled Ahmedabad–Dholera Expressway (NE-8) was inaugurated in March 2026, cutting Ahmedabad–Dholera travel to roughly 45 minutes.",
    tag: "Official Fact",
  },
  {
    title: "Upcoming International Airport",
    body: "Dholera International Airport near Navagam, around 20 km from the SIR boundary, has completed Phase-1 construction and is currently in licensing and trial stages ahead of commercial operations.",
    tag: "Official Fact",
  },
  {
    title: "Plug-and-Play Infrastructure",
    body: "The 22.5 sq km Activation Area has trunk infrastructure in place — internal roads, power, water and ICT ducting — designed for industries to set up quickly.",
    tag: "Official Fact",
  },
  {
    title: "Planned Urban Development",
    body: "Around 422 sq km of developable area is organised into six Town Planning (TP) schemes, with residential, commercial and industrial zones laid out in advance.",
    tag: "Official Fact",
  },
  {
    title: "Long-Term Investment Perspective",
    body: "As infrastructure and industry develop, many investors are watching Dholera for long-term land opportunities. Growth timelines depend on execution — outcomes are never guaranteed.",
    tag: "Investment Perspective — Not a Guarantee",
  },
];

export const ABOUT_VALUES = [
  { title: "Transparent Communication", body: "Clear, honest conversations about what is available, at what price, and what to check before you commit." },
  { title: "Property Guidance", body: "Help understanding locations, plot types, zoning and the documents involved in a Dholera purchase." },
  { title: "Customer-First Service", body: "Advice built around your budget and goals — never pressure, and no invented claims." },
  { title: "End-to-End Assistance", body: "Support from your first enquiry through site visits, documentation and the purchase process." },
];

export const PROPERTY_CATEGORIES = [
  {
    id: "residential",
    name: "Residential Plots",
    image:
      "https://images.unsplash.com/photo-1741526997954-a27031862fb7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    alt: "Residential plots in Dholera Smart City, Gujarat — aerial view of plotted development",
    listing: "Residential Plots — Dholera SIR Region",
    location: "Residential & TP scheme zones, Dholera",
    sizes: "Approx. 100 – 500 sq yd",
    price: "Price on request",
    highlights: ["Plotted layouts near residential zones", "Wide internal roads (as per layout)", "Suitable for future home construction"],
    status: "Enquiry-Based Availability",
  },
  {
    id: "commercial",
    name: "Commercial Plots",
    image:
      "https://images.unsplash.com/photo-1758304481667-71d545c91241?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    alt: "Commercial plots for sale in Dholera Smart City — modern commercial development aerial view",
    listing: "Commercial Plots — Main Road Frontage",
    location: "Highway & town-centre frontages, Dholera",
    sizes: "Approx. 100 – 1,000 sq yd",
    price: "Price on request",
    highlights: ["Road-frontage options for shops & showrooms", "Visibility on high-traffic corridors", "Ideal for early-mover businesses"],
    status: "Enquiry-Based Availability",
  },
  {
    id: "industrial",
    name: "Industrial Opportunities",
    image:
      "https://images.unsplash.com/photo-1786913508089-e27084a2bc52?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    alt: "Industrial land and warehouse opportunities in Dholera SIR, Gujarat",
    listing: "Industrial Land — In & Around SIR Zones",
    location: "Industrial zones, Dholera SIR",
    sizes: "Approx. 1,000+ sq yd",
    price: "Price on request",
    highlights: ["For warehouses & manufacturing units", "Close to the Activation Area corridor", "Subject to applicable zone approvals"],
    status: "Enquiry-Based Availability",
  },
  {
    id: "investment",
    name: "Investment Properties",
    image:
      "https://images.unsplash.com/photo-1515259387710-51e175f9ec6d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    alt: "Investment land parcels in Dholera real estate — open land aerial view",
    listing: "Investment Land Parcels — Growth Corridors",
    location: "Growth corridors around Dholera",
    sizes: "Approx. 500 – 2,000 sq yd",
    price: "Price on request",
    highlights: ["Long-term landholding options", "Options across budget ranges", "Guidance on documentation & verification"],
    status: "Enquiry-Based Availability",
  },
];

export const PROJECTS = [
  {
    name: "Residential Township Plots",
    image:
      "https://images.unsplash.com/photo-1623857619945-b4e718e2256d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    alt: "Dholera residential township plots near Dholera Smart City — aerial development site",
    location: "Dholera SIR residential belt, Gujarat",
    type: "Residential Plots",
    sizes: "100 – 500 sq yd",
    features: ["Plotted township layout (proposed)", "Internal roads & boundary (as per plan)", "Near planned residential zone"],
  },
  {
    name: "Highway-Frontage Commercial Plots",
    image:
      "https://images.unsplash.com/photo-1758304481407-fc50ac2311c8?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    alt: "Commercial property with highway frontage near Dholera Smart City, Gujarat",
    location: "Expressway-linked corridors, Dholera",
    type: "Commercial Plots",
    sizes: "100 – 1,000 sq yd",
    features: ["Main-road frontage options", "Retail / showroom potential", "High visibility for early businesses"],
  },
  {
    name: "Logistics & Warehouse Land",
    image:
      "https://images.unsplash.com/photo-1782750024141-ba9d4e65ea2f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    alt: "Industrial and logistics land near Dholera SIR industrial corridor, Gujarat",
    location: "Industrial corridor, Dholera SIR",
    type: "Industrial Land",
    sizes: "1,000+ sq yd",
    features: ["Suited for warehousing & logistics", "Trunk infrastructure nearby", "Approvals subject to zoning"],
  },
];

export const CONNECTIVITY = [
  { icon: "road", title: "Ahmedabad–Dholera Expressway (NE-8)", detail: "109 km access-controlled greenfield expressway — operational since March 2026. Ahmedabad to Dholera in about 45 minutes (approx. 83 km)." },
  { icon: "plane", title: "Dholera International Airport", detail: "Greenfield airport near Navagam, approx. 20 km from the SIR boundary. Phase-1 construction completed December 2025; licensing and trial operations are underway." },
  { icon: "train", title: "Coastal Highway & Regional Links", detail: "Connection to the coastal highway toward Bhavnagar — Ahmedabad to Bhavnagar now approx. 141 km, around 1 hour 45 minutes by expressway." },
  { icon: "building", title: "Activation Area Development", detail: "The 22.5 sq km Activation Area (TP2A & TP4) has trunk roads, power, water and ICT ducting in place, with industrial plot allotments progressing." },
];

export const GUIDE_FACTORS = [
  { title: "Infrastructure Development", body: "Expressway, airport and trunk infrastructure are being delivered by government agencies — the physical foundations investors look for." },
  { title: "Industrial Ecosystem", body: "Dholera SIR is being positioned as a high-tech manufacturing and industrial hub along the Delhi–Mumbai Industrial Corridor." },
  { title: "Government-Backed Development", body: "Planned and implemented through DSIRDA and DICDL — a 51:49 SPV of the Gujarat and Indian governments." },
  { title: "Connectivity", body: "Road, air and port-linked corridors connect Dholera to Ahmedabad, Bhavnagar and global markets." },
  { title: "Planned Urban Development", body: "Zones for residential, commercial and industrial use are laid out in advance through Town Planning schemes." },
  { title: "Potential Long-Term Demand", body: "As population and industry grow into the master plan, land use patterns may evolve — a perspective some investors find compelling." },
];

export const GUIDE_STEPS = [
  { step: "01", title: "Free Consultation", body: "Call or WhatsApp us. We understand your budget, intent and timeline." },
  { step: "02", title: "Shortlist & Document Guidance", body: "We share matching options and guide you on the documents and approvals to verify." },
  { step: "03", title: "Assisted Site Visit", body: "Visit Dholera with us — now roughly 45 minutes from Ahmedabad via the expressway." },
  { step: "04", title: "Support Through Purchase", body: "We assist with paperwork coordination and stay available after your purchase." },
];

export const FAQS = [
  {
    q: "What is Dholera Smart City?",
    a: "Dholera Special Investment Region (SIR) is a greenfield industrial smart city being developed about 100 km southwest of Ahmedabad, Gujarat, as part of the Delhi–Mumbai Industrial Corridor. It is planned by DSIRDA and implemented by DICDL, a 51:49 joint venture of the Government of Gujarat and the Government of India, across a notified area of around 920 sq km.",
  },
  {
    q: "What types of properties are available in Dholera?",
    a: "Buyers typically explore residential plots, commercial plots, industrial land and long-term investment land parcels in and around Dholera SIR. Exact availability, locations and pricing change frequently — enquire with us for current options that match your budget.",
  },
  {
    q: "How can I enquire about a property?",
    a: "Call or WhatsApp +91 7988500427, email aggarwalsunilhisar@gmail.com, or fill the enquiry form on this page. Share your preferred property type and budget, and we will respond with suitable options and next steps.",
  },
  {
    q: "What documents should I verify before purchasing?",
    a: "Commonly verified documents include the title deed, land records (7/12 extract), Non-Agricultural (NA) order, Town Planning / Final Plot scheme details and applicable approvals. We strongly recommend independent verification through official DSIRDA and revenue records, and consulting a lawyer before purchase. We guide you through what to check, but verification is essential.",
  },
  {
    q: "Can I visit the property or project site?",
    a: "Yes. We coordinate site visits so you can see the location, surroundings and access for yourself. With the Ahmedabad–Dholera Expressway operational since March 2026, Dholera is roughly 45 minutes from Ahmedabad.",
  },
  {
    q: "How can I contact Paras Real Estate?",
    a: "You can reach Sunil Aggarwal on +91 7988500427 (call or WhatsApp) or email aggarwalsunilhisar@gmail.com. You can also send an enquiry through this website and we will get back to you.",
  },
];

export const BUDGET_OPTIONS = [
  "Under ₹10 Lakh",
  "₹10 Lakh – ₹25 Lakh",
  "₹25 Lakh – ₹50 Lakh",
  "₹50 Lakh – ₹1 Crore",
  "Above ₹1 Crore",
  "Not Sure Yet",
];

export const PROPERTY_TYPE_OPTIONS = [
  "Residential Plot",
  "Commercial Plot",
  "Industrial Land",
  "Investment Land",
  "Not Sure — Advise Me",
];

export const INVESTMENT_DISCLAIMER =
  "Real estate investments involve risks. Information presented on this website is for general information purposes and should not be considered financial or investment advice. Buyers should independently verify property documents, approvals, title, pricing and applicable regulations before investing.";
